export default "__VITE_ASSET__GWpzEfCI__"